export default __webpack_public_path__ + "static/media/project-update-icon.d6c0ee81.svg";